import { useContext } from "react";
import { ThemeContext } from "@/contexts/ThemeContext";

const useThemeVariant = () => useContext(ThemeContext);

export default useThemeVariant;
